import { getCookie } from '@mindtickle/utils/cookies';

import { BANNER_CLOSE_COOKIE_VALUE } from '../constants';
import { BANNER_COLORS, BANNER_TYPE, BannerData } from '../types';

interface MaintenanceBannerData extends BannerData {
  endTime: number;
  startTime: number;
  cookieName: string;
}

export const getQueryParams = (searchParams: URLSearchParams): Record<string, string> => {
  const queryParams: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams;
};

export const isMaintenanceActive = ({
  endTime,
  startTime,
  cookieName,
}: MaintenanceBannerData): boolean =>
  Date.now() - startTime > 0 &&
  Date.now() - endTime < 0 &&
  getCookie(cookieName) !== BANNER_CLOSE_COOKIE_VALUE;

// eslint-disable-next-line complexity
export const getRouteBasedBannerData = (
  bannerData: Record<string, BannerData>,
  pathName: string
): [string, BannerData] | [] => {
  const routes = Object.keys(bannerData);
  if (routes.length > 0) {
    if (
      routes.includes(pathName) &&
      isMaintenanceActive((bannerData[pathName] as unknown) as MaintenanceBannerData)
    ) {
      return [pathName, bannerData[pathName]];
    }

    const filteredRoute = routes.find(route => {
      if (route.endsWith('*') && route.length > 1) {
        const baseRoute = route.slice(0, -2);
        return (
          pathName.startsWith(baseRoute) &&
          isMaintenanceActive((bannerData[route] as unknown) as MaintenanceBannerData)
        );
      }
      return false;
    });

    if (filteredRoute) {
      return [filteredRoute, bannerData[filteredRoute]];
    }

    if (
      routes.includes('*') &&
      isMaintenanceActive((bannerData['*'] as unknown) as MaintenanceBannerData)
    ) {
      return ['*', bannerData['*']];
    }
  }

  return [];
};

export const getBannerStyles = (bannerType: keyof typeof BANNER_TYPE) => {
  const { border, background, icon } =
    BANNER_COLORS[bannerType] || BANNER_COLORS[BANNER_TYPE.WARNING];
  return {
    border,
    background,
    icon,
  };
};
